import React, { useState } from 'react';
import InventaireList from '../components/inventaire/InventaireList';
import SingleInventaire from '../components/inventaire/SingleInventaire';

const InventairePage = () => {
  const [view, setView] = useState('list');
  const [selectedInventaireId, setSelectedInventaireId] = useState(null);

  const handleSelectInventaire = (id) => {
    setSelectedInventaireId(id);
    setView('single');
  };

  const handleBack = () => {
    setView('list');
    setSelectedInventaireId(null);
  };

  return (
    <div style={{ padding: '24px' }}>
      {view === 'list' && (
        <InventaireList onSelectInventaire={handleSelectInventaire} />
      )}
      {view === 'single' && selectedInventaireId && (
        <SingleInventaire id={selectedInventaireId} onBack={handleBack} />
      )}
    </div>
  );
};

export default InventairePage;














